import React from 'react'
import { Row, Col, Container } from 'reactstrap'
import selo from '../../images/Footer/selo.svg'

// import logofsc from '../../images/Footer/logofsc.jpg'
import './style.scss'
export default function Footer () {
  return (
    <div className="bg-005A9C text-center footer">
      <Container>
        <Row>
          <Col className="py-3" xs="4" sm="4" md="4">
            <a href="tel:+551147936560"
            className='text-white-footer' >
              <i
                className="fa fa-phone px-3"
                aria-hidden="true"
                style={{ fontSize: '1.5rem' }}
              />
              <a
                className="d-none d-sm-none d-md-inline text-white-footer"
                style={{ fontSize: '0.9rem' }}
              >
                +55 11 4793.6560
              </a>
            </a>
          </Col>
          <Col className="py-3" xs="4" sm="3" md="2">
            <a
              href="https://api.whatsapp.com/send?phone=5511982593207"
              className="text-white-footer"
            >
              <i
                className="fa fa-whatsapp px-3"
                aria-hidden="true"
                style={{ fontSize: '1.5rem' }}
              />
              <a
                className="d-none d-sm-none d-md-inline text-white-footer"
                style={{ fontSize: '0.9rem' }}
              >
                WhatsApp
              </a>
            </a>
          </Col>
          <Col className="py-3" xs="4" sm="5" md="6">
            <a
              href="https://www.google.com.br/maps/place/Savasa+Impressores+Ltda/@-23.5157672,-46.1563162,19.43z/data=!4m13!1m7!3m6!1s0x94cdd9bf46d88f8d:0x4a6139f8362242c0!2sAv.+Pres.+Castelo+Branco,+505+-+Cezar+de+Souza,+Mogi+das+Cruzes+-+SP!3b1!8m2!3d-23.5153744!4d-46.1557147!3m4!1s0x94cdd9bf2260a9a1:0xdcf459a1d2dd6905!8m2!3d-23.5153681!4d-46.1557301"
              className="text-white-footer"
            >
              <i
                className="fa fa-map-marker px-3"
                aria-hidden="true"
                style={{ fontSize: '1.5rem' }}
              />
              <a
                className="d-none d-sm-none d-md-inline text-white-footer"
                style={{ fontSize: '0.9rem' }}
              >
                Av. Pres. Castelo Branco, 505 Mogi das Cruzes SP
              </a>
            </a>
          </Col>
        </Row>
      </Container>
      {/* <Col className="text-center mb-3">
        <div className="row justify-content-center" id="Logos">
          <div className="mr-5 pt-2">
            <a href="https://profiles.dunsregistered.com/TPBR-BAS-004_POR.aspx?PaArea=1">
              <img src={selo} alt="selo" className="selo" />
            </a>
          </div>
          <div className="col-6 justify-content-center">
            <a href="https://fsc.org/">
              <img src={logofsc} alt="logofsc" className="logofsc" />
            </a>
          </div>
        </div>
      </Col> */}
      <div className='container-fluid py-2 bg-white'>
        <div className='row justify-content-center'>
          <div className='col-lg-2 col-6'>
            <a href="https://profiles.dunsregistered.com/TPBR-BAS-004_POR.aspx?PaArea=1">
                    <img src={selo} alt="selo" className="selo" />
            </a>
          </div>
          {/* <div className='col-lg-2 col-6'>
            <a href="https://fsc.org/">
                    <img src={logofsc} alt="logofsc" className="logofsc" />
            </a>
          </div> */}
        </div>
      </div>
      <div className="container py-3">
        <p className="m-0 text-center">
          <a className="clouddog" href="https://www.clouddog.com.br">
            Desenvolvido por CloudDog
          </a>
        </p>
      </div>
    </div>
  )
}
